import React from "react";
import { FiCheck } from "react-icons/fi";
import { RDV_BUTTONS } from "../../utils/whatsapp";
import bannerImage from "../../assets/images/appImages/aproche1.jpeg";

const TRUST_ITEMS = [
  "Écoute et accompagnement personnalisé",
  "Hygiène et sécurité",
  "Produits sélectionnés avec attention",
  "Pratiques responsables et références vérifiées",
];

function FoutaBanner() {
  return (
    <section className="foutabio-banner" aria-label="FoutaBio">
      <div className="foutabio-banner-main">
        <div className="foutabio-banner-content">
          <p className="foutabio-banner-eyebrow">
            Phytothérapie · Médecine prophétique · Hijama · Roqya
          </p>

          <h1 className="foutabio-banner-title">
            Savoir.
            <br />
            Comprendre.
            <br />
            <em className="foutabio-banner-title-accent">Accompagner.</em>
          </h1>

          <p className="foutabio-banner-text">
            Fouta Bio vous accompagne dans une démarche globale de bien-être
            fondée sur l'écoute, la médecine prophétique, la phytothérapie et
            des pratiques traditionnelles responsables.
          </p>

          <div className="foutabio-banner-cta">
            {RDV_BUTTONS.map((rdv) => (
              <a
                key={rdv.country}
                href={rdv.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`foutabio-btn foutabio-btn-rdv foutabio-btn-rdv-${rdv.country.toLowerCase()}`}
              >
                {rdv.label}
              </a>
            ))}
          </div>
        </div>

        <div className="foutabio-banner-image-wrapper">
          <img
            src={bannerImage}
            alt="Spécialiste préparant des plantes médicinales"
            className="foutabio-banner-image"
            decoding="async"
            fetchPriority="high"
          />
        </div>
      </div>

      <div className="foutabio-banner-trust">
        <ul className="foutabio-banner-trust-list">
          {TRUST_ITEMS.map((label) => (
            <li key={label} className="foutabio-banner-trust-item">
              <FiCheck className="foutabio-banner-trust-icon" />
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default FoutaBanner;
